module.exports = __webpack_public_path__ + "static/media/report-card-bg.601b4ddc.png";